import { render, staticRenderFns } from "./ColorNotesDialog.vue?vue&type=template&id=c8a16bd2&scoped=true&"
import script from "./ColorNotesDialog.vue?vue&type=script&lang=js&"
export * from "./ColorNotesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a16bd2",
  null
  
)

export default component.exports